export const WEBSOCKET_NEW_RECEIVED_MESSAGE = 'WEBSOCKET/NEW_RECEIVED_MESSAGE';
export const WEBSOCKET_CHANGE_STATUS = 'WEBSOCKET/WEBSOCKET_CHANGE_STATUS';
